"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stytchCryptoExchangeCodeSaga = exports.stytchCryptoExchangeCodeResponse = exports.stytchCryptoExchangeCode = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const typed_redux_saga_1 = require("typed-redux-saga");
const api_1 = require("../../api");
const storageManagement_1 = require("../tokens-storage/storageManagement");
const adaptStorage_1 = require("../tokens-storage/adaptStorage");
const stytchClearStoreSaga_1 = require("./stytchClearStoreSaga");
const stytchGetCurrentUserSaga_1 = require("./stytchGetCurrentUserSaga");
const stytchLoadingSlot_1 = require("./stytchLoadingSlot");
const stytchSetAuthenticatedSaga_1 = require("./stytchSetAuthenticatedSaga");
const stytchWarning_1 = require("./stytchWarning");
exports.stytchCryptoExchangeCode = (0, toolkit_1.createAction)('AUTHENTICATION/STYTCH/CRYPTO/EXCHANGE_CODE');
exports.stytchCryptoExchangeCodeResponse = (0, toolkit_1.createAction)('AUTHENTICATION/STYTCH/CRYPTO/EXCHANGE_CODE/SIGN_UP/RESPONSE');
function* stytchCryptoExchangeCodeSaga({ payload: { signature, wallet, walletType, enableNewsletter, isUserCreated, termsAccepted, userId, }, }) {
    yield* (0, typed_redux_saga_1.put)((0, stytchWarning_1.stytchClearWarnings)());
    yield* (0, typed_redux_saga_1.put)((0, stytchLoadingSlot_1.stytchSetLoadingSlot)({
        slot: stytchLoadingSlot_1.StytchLoadingSlot.CRYPTO_EXCHANGE_CODE,
        loading: true,
    }));
    try {
        const userServiceAddress = yield* (0, typed_redux_saga_1.call)(typed_redux_saga_1.getContext, 'userServiceAddress');
        const response = yield* (0, typed_redux_saga_1.call)(api_1.stytchFetchCryptoExchangeAccessCode, signature, wallet, walletType, userServiceAddress, isUserCreated, userId, termsAccepted, enableNewsletter);
        if (response.ok) {
            const storage = yield* (0, typed_redux_saga_1.call)(typed_redux_saga_1.getContext, 'storage');
            const adaptedStorage = (0, adaptStorage_1.adaptStorage)(storage);
            const responseJson = yield* (0, typed_redux_saga_1.call)([response, 'json']);
            const accessToken = responseJson.session_jwt;
            yield* (0, typed_redux_saga_1.put)((0, stytchClearStoreSaga_1.stytchClearStore)());
            yield* (0, typed_redux_saga_1.put)((0, stytchGetCurrentUserSaga_1.stytchGetCurrentUser)({
                accessToken,
            }));
            yield* (0, typed_redux_saga_1.call)(storageManagement_1.setAccessToken, adaptedStorage, accessToken);
            yield* (0, typed_redux_saga_1.call)(storageManagement_1.setOldAccessToken, adaptedStorage, accessToken);
            if (termsAccepted) {
                // Sign Up process
                // We display success screen only for Sign Up
                yield* (0, typed_redux_saga_1.put)((0, exports.stytchCryptoExchangeCodeResponse)({
                    tokenExchangeSuccess: true,
                }));
            }
            else {
                // Sign In process
                yield* (0, typed_redux_saga_1.put)((0, stytchSetAuthenticatedSaga_1.stytchSetAuthenticated)(true));
            }
        }
        else if (response.status === 422) {
            const responseJson = yield* (0, typed_redux_saga_1.call)([response, 'json']);
            yield* (0, typed_redux_saga_1.put)((0, stytchWarning_1.stytchSetWarning)({
                slot: stytchWarning_1.StytchWarningSlot.CRYPTO_EXCHANGE_CODE,
                isValid: false,
                message: responseJson.detail,
            }));
            yield* (0, typed_redux_saga_1.put)((0, exports.stytchCryptoExchangeCodeResponse)({
                tokenExchangeSuccess: false,
            }));
        }
        else {
            yield* (0, typed_redux_saga_1.put)((0, stytchWarning_1.stytchSetWarning)({
                slot: stytchWarning_1.StytchWarningSlot.CRYPTO_EXCHANGE_CODE,
                isValid: false,
                message: stytchWarning_1.StytchWarningMessage.CRYPTO_EXCHANGE_CODE,
            }));
            yield* (0, typed_redux_saga_1.put)((0, exports.stytchCryptoExchangeCodeResponse)({
                tokenExchangeSuccess: false,
            }));
        }
    }
    catch (e) {
        const { message: errorMessage } = e;
        if (errorMessage) {
            yield* (0, typed_redux_saga_1.put)((0, stytchWarning_1.stytchSetWarning)({
                slot: stytchWarning_1.StytchWarningSlot.CRYPTO_EXCHANGE_CODE,
                isValid: false,
                message: errorMessage,
            }));
        }
        else {
            yield* (0, typed_redux_saga_1.put)((0, stytchWarning_1.stytchSetWarning)({
                slot: stytchWarning_1.StytchWarningSlot.CRYPTO_EXCHANGE_CODE,
                isValid: false,
                message: stytchWarning_1.StytchWarningMessage.CRYPTO_EXCHANGE_CODE,
            }));
        }
        yield* (0, typed_redux_saga_1.put)((0, exports.stytchCryptoExchangeCodeResponse)({
            tokenExchangeSuccess: false,
        }));
    }
    finally {
        yield* (0, typed_redux_saga_1.put)((0, stytchLoadingSlot_1.stytchSetLoadingSlot)({
            slot: stytchLoadingSlot_1.StytchLoadingSlot.CRYPTO_EXCHANGE_CODE,
            loading: false,
        }));
    }
}
exports.stytchCryptoExchangeCodeSaga = stytchCryptoExchangeCodeSaga;
